import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Layout from '../../reusables/layout/layout';
import RequisitionTradeTest from '../../Component/requisitionforms/requisitionTradeTest';

// const CustomTextField = styled(TextField)({
//   "& .MuiInputBase-input.Mui-disabled": {
//     color: "rgba(0,0,0,0.6) !important",
//     "-webkit-text-fill-color": "rgba(0,0,0,0.6) !important",
//     borderColor: "rgba(0,0,0,0.6) !important",
//   },
// });

const TradeTest = () => {

  const token = useSelector((state) => state?.user?.data?.token);


  return (
    <div>
      <Layout>
        {/* {token && */}
          <RequisitionTradeTest examType={'TRADE TEST'} examName={'Trade Test'} />
        {/* } */}
        {/* <ProceedModalPrint pin={pinNum} open={open} handleClose={handleClose} /> */}
      </Layout>
    </div>
  );
};

export default TradeTest;